var a={sideNavGroup:"lds-side-nav-group",label:"lds-side-nav-group--label"};export{a as default};
